// extracted by mini-css-extract-plugin
export default {"footer":"SelectedCountFooter__footer-wcAeC","selectedAppsCount":"SelectedCountFooter__selectedAppsCount-_E9k2"};